import React, { createContext, useState, useEffect } from 'react';
import { fetchAllDataFromSheets, fetchAllTranscripts, fetchAllCatechismAttendance, fetchAllCatechists } from './GoogleSheetsService';

export const StudentContext = createContext();

const originalClassMap = {
  'to-mau': 'Tô Màu',
  'khai-tam-1a-nu': 'Khai Tâm 1A Nữ',
  'khai-tam-1b-nam': 'Khai Tâm 1B Nam',
  'khai-tam-2a-nu': 'Khai Tâm 2A Nữ',
  'khai-tam-2b-nu': 'Khai Tâm 2B Nữ',
  'khai-tam-2c-nam': 'Khai Tâm 2C Nam',
  'khai-tam-2d-nam': 'Khai Tâm 2D Nam',
  'ruoc-le-1a-nu': 'Rước Lễ 1A Nữ',
  'ruoc-le-1b-nu': 'Rước Lễ 1B Nữ',
  'ruoc-le-1c-nam': 'Rước Lễ 1C Nam',
  'ruoc-le-1d-nam': 'Rước Lễ 1D Nam',
  'ruoc-le-2a-nu': 'Rước Lễ 2A Nữ',
  'ruoc-le-2b-nu': 'Rước Lễ 2B Nữ',
  'ruoc-le-2c-nam': 'Rước Lễ 2C Nam',
  'ruoc-le-2d-nam': 'Rước Lễ 2D Nam',
  'them-suc-1a-nu': 'Thêm Sức 1A Nữ',
  'them-suc-1b-nu': 'Thêm Sức 1B Nữ',
  'them-suc-1c-nam': 'Thêm Sức 1C Nam',
  'them-suc-1d-nam': 'Thêm Sức 1D Nam',
  'them-suc-2a-nu': 'Thêm Sức 2A Nữ',
  'them-suc-2b-nu': 'Thêm Sức 2B Nữ',
  'them-suc-2c-nam': 'Thêm Sức 2C Nam',
  'them-suc-2d-nam': 'Thêm Sức 2D Nam',
  'bao-dong-1a-nu': 'Bao Đồng 1A Nữ',
  'bao-dong-1b-nam': 'Bao Đồng 1B Nam',
  'bao-dong-2a-nu': 'Bao Đồng 2A Nữ',
  'bao-dong-2b-nam': 'Bao Đồng 2B Nam',
  'bao-dong-3': 'Bao Đồng 3',
  'bao-dong-4': 'Bao Đồng 4',
  'du-bi-giao-ly-vien': 'Dự Bị Giáo Lý Viên',
};

const originalBlocks = {
  'khai-tam': [
    { id: 'to-mau', name: 'Tô Màu' },
    { id: 'khai-tam-1a-nu', name: 'Khai Tâm 1A Nữ' },
    { id: 'khai-tam-1b-nam', name: 'Khai Tâm 1B Nam' },
    { id: 'khai-tam-2a-nu', name: 'Khai Tâm 2A Nữ' },
    { id: 'khai-tam-2b-nu', name: 'Khai Tâm 2B Nữ' },
    { id: 'khai-tam-2c-nam', name: 'Khai Tâm 2C Nam' },
    { id: 'khai-tam-2d-nam', name: 'Khai Tâm 2D Nam' },
  ],
  'ruoc-le': [
    { id: 'ruoc-le-1a-nu', name: 'Rước Lễ 1A Nữ' },
    { id: 'ruoc-le-1b-nu', name: 'Rước Lễ 1B Nữ' },
    { id: 'ruoc-le-1c-nam', name: 'Rước Lễ 1C Nam' },
    { id: 'ruoc-le-1d-nam', name: 'Rước Lễ 1D Nam' },
    { id: 'ruoc-le-2a-nu', name: 'Rước Lễ 2A Nữ' },
    { id: 'ruoc-le-2b-nu', name: 'Rước Lễ 2B Nữ' },
    { id: 'ruoc-le-2c-nam', name: 'Rước Lễ 2C Nam' },
    { id: 'ruoc-le-2d-nam', name: 'Rước Lễ 2D Nam' },
  ],
  'them-suc': [
    { id: 'them-suc-1a-nu', name: 'Thêm Sức 1A Nữ' },
    { id: 'them-suc-1b-nu', name: 'Thêm Sức 1B Nữ' },
    { id: 'them-suc-1c-nam', name: 'Thêm Sức 1C Nam' },
    { id: 'them-suc-1d-nam', name: 'Thêm Sức 1D Nam' },
    { id: 'them-suc-2a-nu', name: 'Thêm Sức 2A Nữ' },
    { id: 'them-suc-2b-nu', name: 'Thêm Sức 2B Nữ' },
    { id: 'them-suc-2c-nam', name: 'Thêm Sức 2C Nam' },
    { id: 'them-suc-2d-nam', name: 'Thêm Sức 2D Nam' },
  ],
  'bao-dong': [
    { id: 'bao-dong-1a-nu', name: 'Bao Đồng 1A Nữ' },
    { id: 'bao-dong-1b-nam', name: 'Bao Đồng 1B Nam' },
    { id: 'bao-dong-2a-nu', name: 'Bao Đồng 2A Nữ' },
    { id: 'bao-dong-2b-nam', name: 'Bao Đồng 2B Nam' },
    { id: 'bao-dong-3', name: 'Bao Đồng 3' },
    { id: 'bao-dong-4', name: 'Bao Đồng 4' },
    { id: 'du-bi-giao-ly-vien', name: 'Dự Bị Giáo Lý Viên' },
  ],
};

export const StudentProvider = ({ children }) => {
  const [studentsData, setStudentsData] = useState({});
  const [transcriptsData, setTranscriptsData] = useState({});
  const [catechistsData, setCatechistsData] = useState([]);
  const [attendanceDates, setAttendanceDates] = useState([]);
  const [catechismAttendanceDates, setCatechismAttendanceDates] = useState([]);
  const [visibleBlocks, setVisibleBlocks] = useState({});
  const [isLoading, setIsLoading] = useState(false);
  const [isDataLoaded, setIsDataLoaded] = useState(false);

  const loadAllData = async () => {
    if (isDataLoaded) {
      console.log('Data already loaded - Skipping loadAllData');
      return;
    }

    console.log('loadAllData called - Loading all data without filtering');
    setIsLoading(true);

    const data = await fetchAllDataFromSheets();
    const catechismAttendanceData = await fetchAllCatechismAttendance();
    const catechistsData = await fetchAllCatechists();
    let finalStudentsData = {};
    const allDates = data.dates || [];
    const allCatechismDates = catechismAttendanceData.dates || [];

    const transcriptResponse = await fetchAllTranscripts();
    const allTranscripts = transcriptResponse || [];
    let finalTranscriptsData = {};

    for (const blockId in originalBlocks) {
      const classes = originalBlocks[blockId];
      for (const classItem of classes) {
        const className = originalClassMap[classItem.id];
        if (!className) continue;

        const studentList = data.students.filter((student) => student.className === className);
        const attendanceList = data.attendance.filter((att) =>
          studentList.some((s) => s.id === att.id)
        );

        const catechismAttendanceList = catechismAttendanceData.attendance.filter(
          (att) => att.className === className
        );

        const studentsWithAttendance = studentList.map((student) => {
          const attendanceRecord = attendanceList.find((att) => att.id === student.id);
          const catechismAttendanceRecord = catechismAttendanceList.find((att) => att.id === student.id);
          return {
            ...student,
            attendance: attendanceRecord ? attendanceRecord.attendance : {},
            catechismAttendance: catechismAttendanceRecord ? catechismAttendanceRecord.attendance : {},
          };
        });
        finalStudentsData[classItem.id] = studentsWithAttendance;

        const transcriptList = allTranscripts.filter((transcript) => transcript.className === className);
        finalTranscriptsData[classItem.id] = transcriptList;
      }
    }

    console.log('All students data:', finalStudentsData);
    console.log('All transcripts data:', finalTranscriptsData);
    console.log('All catechists data:', catechistsData);
    setStudentsData(finalStudentsData);
    setTranscriptsData(finalTranscriptsData);
    setCatechistsData(catechistsData);
    setAttendanceDates(allDates);
    setCatechismAttendanceDates(allCatechismDates);
    setIsDataLoaded(true);
    setIsLoading(false);
  };

  const loadAndFilterData = async () => {
    console.log('loadAndFilterData called - Starting data load process');
    setIsLoading(true);

    const isLoggedIn = localStorage.getItem('isLoggedIn');
    if (!isLoggedIn) {
      console.log('User not logged in - No data loaded');
      setStudentsData({});
      setTranscriptsData({});
      setCatechistsData([]);
      setVisibleBlocks({});
      setAttendanceDates([]);
      setCatechismAttendanceDates([]);
      setIsLoading(false);
      return;
    }

    console.log('User logged in - Checking user role');
    const userRole = localStorage.getItem('userRole') || 'catechist';
    const catechistClassDisplayName = localStorage.getItem('catechistClassName');
    const blockLeader = localStorage.getItem('blockLeader');
    const boardLeader = localStorage.getItem('boardLeader');

    console.log('Fetching data from Google Sheets');
    const data = await fetchAllDataFromSheets();
    const catechismAttendanceData = await fetchAllCatechismAttendance();
    const catechistsData = await fetchAllCatechists();
    const transcriptResponse = await fetchAllTranscripts();
    const allTranscripts = transcriptResponse || [];

    let finalStudentsData = {};
    let finalTranscriptsData = {};
    let finalVisibleBlocks = {};
    const allDates = data.dates || [];
    const allCatechismDates = catechismAttendanceData.dates || [];

    const blockDisplayNameToId = {
      'Khối Khai Tâm': 'khai-tam',
      'Khối Thêm Sức': 'them-suc',
      'Khối Rước Lễ': 'ruoc-le',
      'Khối Bao Đồng': 'bao-dong',
    };

    if (userRole === 'admin' || boardLeader === 'Ban kỷ luật') {
      console.log(`User role is ${userRole} or boardLeader is Ban kỷ luật - Loading all data`);
      finalVisibleBlocks = originalBlocks;

      for (const blockId in originalBlocks) {
        const classes = originalBlocks[blockId];
        for (const classItem of classes) {
          const className = originalClassMap[classItem.id];
          if (!className) continue;

          const studentList = data.students.filter((student) => student.className === className);
          const attendanceList = data.attendance.filter((att) =>
            studentList.some((s) => s.id === att.id)
          );

          const catechismAttendanceList = catechismAttendanceData.attendance.filter(
            (att) => att.className === className
          );

          const studentsWithAttendance = studentList.map((student) => {
            const attendanceRecord = attendanceList.find((att) => att.id === student.id);
            const catechismAttendanceRecord = catechismAttendanceList.find((att) => att.id === student.id);
            return {
              ...student,
              attendance: attendanceRecord ? attendanceRecord.attendance : {},
              catechismAttendance: catechismAttendanceRecord ? catechismAttendanceRecord.attendance : {},
            };
          });
          finalStudentsData[classItem.id] = studentsWithAttendance;

          const transcriptList = allTranscripts.filter((transcript) => transcript.className === className);
          finalTranscriptsData[classItem.id] = transcriptList;
        }
      }
    } else if (userRole === 'catechist' && blockLeader && blockDisplayNameToId[blockLeader]) {
      console.log(`User is blockLeader for ${blockLeader} - Loading all classes in block`);
      const targetBlockId = blockDisplayNameToId[blockLeader];

      const classesInBlock = originalBlocks[targetBlockId] || [];
      finalVisibleBlocks[targetBlockId] = classesInBlock;

      for (const classItem of classesInBlock) {
        const className = originalClassMap[classItem.id];
        if (!className) continue;

        const studentList = data.students.filter((student) => student.className === className);
        const attendanceList = data.attendance.filter((att) =>
          studentList.some((s) => s.id === att.id)
        );

        const catechismAttendanceList = catechismAttendanceData.attendance.filter(
          (att) => att.className === className
        );

        const studentsWithAttendance = studentList.map((student) => {
          const attendanceRecord = attendanceList.find((att) => att.id === student.id);
          const catechismAttendanceRecord = catechismAttendanceList.find((att) => att.id === student.id);
          return {
            ...student,
            attendance: attendanceRecord ? attendanceRecord.attendance : {},
            catechismAttendance: catechismAttendanceRecord ? catechismAttendanceRecord.attendance : {},
          };
        });
        finalStudentsData[classItem.id] = studentsWithAttendance;

        const transcriptList = allTranscripts.filter((transcript) => transcript.className === className);
        finalTranscriptsData[classItem.id] = transcriptList;
      }
    } else {
      console.log('User role is catechist - Filtering data by class');
      let targetBlockId = null;
      let targetClassId = null;
      let targetClassName = null;

      if (catechistClassDisplayName) {
        targetClassName = catechistClassDisplayName;
        for (const blockId in originalBlocks) {
          const classItem = originalBlocks[blockId].find((c) => c.name === targetClassName);
          if (classItem) {
            targetBlockId = blockId;
            targetClassId = classItem.id;
            break;
          }
        }
      }

      if (targetBlockId && targetClassId && targetClassName) {
        console.log(
          `Catechist restricted to: Block=${targetBlockId}, Class=${targetClassId} (${targetClassName})`
        );

        const studentList = data.students.filter((student) => student.className === targetClassName);
        const attendanceList = data.attendance.filter((att) =>
          studentList.some((s) => s.id === att.id)
        );

        const catechismAttendanceList = catechismAttendanceData.attendance.filter(
          (att) => att.className === targetClassName
        );

        const studentsWithAttendance = studentList.map((student) => {
          const attendanceRecord = attendanceList.find((att) => att.id === student.id);
          const catechismAttendanceRecord = catechismAttendanceList.find((att) => att.id === student.id);
          return {
            ...student,
            attendance: attendanceRecord ? attendanceRecord.attendance : {},
            catechismAttendance: catechismAttendanceRecord ? catechismAttendanceRecord.attendance : {},
          };
        });

        finalStudentsData = { [targetClassId]: studentsWithAttendance };

        const transcriptList = allTranscripts.filter((transcript) => transcript.className === targetClassName);
        finalTranscriptsData = { [targetClassId]: transcriptList };

        finalVisibleBlocks = {
          [targetBlockId]: originalBlocks[targetBlockId].filter((c) => c.id === targetClassId),
        };
      } else {
        console.log('Catechist class not found or not assigned - No data loaded');
        finalStudentsData = {};
        finalTranscriptsData = {};
        finalVisibleBlocks = {};
      }
    }

    setStudentsData(finalStudentsData);
    setTranscriptsData(finalTranscriptsData);
    setCatechistsData(catechistsData);
    setVisibleBlocks(finalVisibleBlocks);
    setAttendanceDates(allDates);
    setCatechismAttendanceDates(allCatechismDates);
    setIsDataLoaded(true);
    setIsLoading(false);
  };

  const refreshData = () => {
    console.log('refreshData called');
    setIsDataLoaded(false); // Cho phép tải lại dữ liệu
    loadAndFilterData();
  };

  useEffect(() => {
    console.log('StudentProvider mounted - Checking login status');
    const isLoggedIn = localStorage.getItem('isLoggedIn');
    if (isLoggedIn) {
      console.log('User is logged in - Loading data on mount');
      loadAndFilterData();
    }
  }, []);

  return (
    <StudentContext.Provider
      value={{
        studentsData,
        transcriptsData,
        catechistsData,
        classMap: originalClassMap,
        blocks: visibleBlocks,
        allBlocks: originalBlocks,
        attendanceDates,
        catechismAttendanceDates,
        refreshData,
        isLoading,
        loadAndFilterData,
        loadAllData,
      }}
    >
      {children}
    </StudentContext.Provider>
  );
};